module.exports = __webpack_public_path__ + "img/escudo-white-minsal.f7bacccf.png";